import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DbContextService } from '../../../services/db-context.service';
import { Helper } from '../../common/helper';
import swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class OrderRequestService {

  constructor(private http: HttpClient, private dbxService: DbContextService) { }
  getCountryIDNameList() {
    return this.http.post(Helper.API_URL() + '/api/Maintenance/GetCountryIDNameList', {});
  }

  getHarborListByCountry(countryID: any) {
    // convert to httpPost
    let paramObject = {
      'countryID': countryID
    }
    return this.http.post(Helper.API_URL() + '/api/Maintenance/GetHarborListByCountryId', paramObject);
  }
  getContactIDNameByContactTypeResultSetList() {

    return this.http.post(Helper.API_URL() + '/api/Maintenance/GetContactIDNameByContactTypeResultSetList', {});
  }
  getContactIDNameListByContactType(contactType: any) {

    // convert to httpPost
    let paramObject = {
      'contactType': contactType
    }

    return this.http.post(Helper.API_URL() + '/api/Maintenance/GetContactIDNameListByContactType', paramObject);
  }

  getActiveShipCrewByShipAndCrewSubType(ShipCrewID: any) {
    let paramObject = {
      'crewSubTypeID': ShipCrewID
    }
    return this.http.post(Helper.API_URL() + '/api/Maintenance/GetActiveShipCrewByShipAndCrewSubType', paramObject);
  }

  getShipDetails() {
    return this.http.get(Helper.API_URL() + `/api/Maintenance/GetShips/0`);
  }

  getShipsPreferredSupplierList(harborID?: any) {

    // by default, get All harbor

    // convert to httpPost
    let paramObject = {
      'harborID': (harborID) ? harborID : 'ALL'
    }

    return this.http.post(Helper.API_URL() + '/api/ShipOwner/GetSPreferredSupplierList', paramObject);
  }
  getShipSupplierByNumPastOrder(harborID?: any, departmentID?: any) {

    // by default, get All harbor

    // convert to httpPost
    let paramObject = {
      'harborID': (harborID) ? harborID : '0',
      'departmentID': (departmentID) ? departmentID : '0'
    }

    return this.http.post(Helper.API_URL() + '/api/ShipOwner/GetShipSupplierByNumPastOrder', paramObject);
  }

  getShipSupplierWitHRating(harborID?: any) {

    // by default, get All harbor

    // convert to httpPost
    let paramObject = {
      'harborID': (harborID) ? harborID : 'ALL'
    }

    return this.http.post(Helper.API_URL() + '/api/ShipOwner/GetShipSupplierWitHRating', paramObject);
  }

  getDefaultSupplier(supplierID: any) {

    // by default, get All harbor

    // convert to httpPost
    let paramObject = {
      'supplierID': supplierID,
    }

    return this.http.post(Helper.API_URL() + '/api/Supplier/GetIFSSupplier', paramObject);
  }


  getOrderListWithGroup(departmentID: any, supplierID: any, harborID: any, deliveryDate: any, isHolidayOrder: any, isExtraList: any, isIMI: any, imiOrderID: any) {

    // convert to httpPost
    let paramObject = {
      'departmentID': departmentID,
      'supplierID': supplierID,
      'harborID': harborID,
      'deliveryDate': deliveryDate,
      'isHolidayOrder': isHolidayOrder,
      'isExtraList': isExtraList,
      'isIMI': isIMI,
      'imiOrderID': imiOrderID,
    }

    return this.http.post(Helper.API_URL() + '/api/Orders/OWSGetOrderListWithGroup', paramObject);
  }
  getMaxPercentBudget() {

    return this.http.post(Helper.API_URL() + '/api/Orders/OWSGetMaxPercentBudget', {});
  }
  getBudgetInfo(departmentID: number, supplierID: number, periodEnd: string, noOfDays: number, NoOfCrew: number, isHolidayOrder: boolean) {

    // convert to httpPost
    let paramObject = {
      'departmentID': departmentID,
      'supplierID': supplierID,
      'periodEnd': periodEnd,
      'noOfDays': noOfDays,
      'noOfCrew': NoOfCrew,
      'isHolidayOrder': isHolidayOrder,
    }

    return this.http.post(Helper.API_URL() + '/api/Orders/OWSGetBudgetInfo', paramObject);
  }

  getWeightByCategory(departmentID: number, supplierID: number, periodFrom: string, periodTo: string, noOfDays: number, NoOfCrew: number, NoOfDaysFreshFood: number, isNewOrder: boolean) {

    // convert to httpPost
    let paramObject = {
      'departmentID': departmentID,
      'supplierID': supplierID,
      'periodFrom': periodFrom,
      'periodTo': periodTo,
      'noOfDays': noOfDays,
      'noOfCrew': NoOfCrew,
      'noOfDaysFreshFood': NoOfDaysFreshFood,
      'isNewOrder': isNewOrder
    }

    return this.http.post(Helper.API_URL() + '/api/Orders/OWSGetWeightByCategory', paramObject);
  }

  getExchangeRateBidirectionalMethod(fromCurrencyID: any, toCurrencyID: any, baseDate: any) {
    let httpGetParameter = `${fromCurrencyID}/${toCurrencyID}/${baseDate}`;
    return this.http.get(Helper.API_URL() + '/api/Maintenance/GetExchangeRateBidirectionalMethod/' + httpGetParameter);
  }

  updateOrderAgentName(orderID: number, agentName: string, agentTelephone: string, agentEmail: string) {

    // convert to httpPost
    let paramObject = {
      'orderID': orderID,
      'agentName': agentName,
      'agentTelephone': agentTelephone,
      'agentEmail': agentEmail,
    }

    return this.http.post(Helper.API_URL() + '/api/orders/UpdateOrderAgent', paramObject);
  }

  getOrderListHeaderExtraList(harborID: number) {

    let paramObject = {
      'harborID': harborID,
    }

    return this.http.post(Helper.API_URL() + '/api/Orders/GetOrderListHeaderExtraList', paramObject);
  }

  getMaximumDaysFreshFood() {
    return this.http.get(Helper.API_URL() + '/api/Maintenance/GetMaximumDaysFreshFood');
  }

  //Index DB service operation

  saveOrderHeader(orderHeaderGUID: string, orderHeader: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {

      const obj = {
        orderInfoHeaderID: orderHeaderGUID,
        agentID: orderHeader.agentID,
        captainID: orderHeader.captainID,
        campbossID: orderHeader.campbossID,
        cookID: orderHeader.cookID,
        countryID: orderHeader.countryID,
        coveringDays: orderHeader.coveringDays,
        coveringDaysFreshFood: orderHeader.coveringDaysFreshFood,
        orderDate: orderHeader.orderDate,
        deliveryDate: orderHeader.deliveryDate,
        departmentID: orderHeader.departmentID,
        harborID: orderHeader.harborID,
        nextCountryID: orderHeader.nextCountryID,
        nextHarborID: orderHeader.nextHarborID,
        noOfCrew: orderHeader.noOfCrew,
        orderReviewerID: orderHeader.orderReviewerID,
        // orderHeaderID: orderHeaderGUID,
        shipID: orderHeader.shipID,
        shipName: orderHeader.shipName,
        supplierID: orderHeader.supplierID,
        supplierName: orderHeader.supplierName,
        orderListSupplierID: orderHeader.orderListSupplierID,
        orderListSupplierCurrencyID: orderHeader.orderListSupplierCurrencyID,
        orderListSupplierCurrencyCode: orderHeader.orderListSupplierCurrencyCode,
        orderListSupplierCurrencySymbol: orderHeader.orderListSupplierCurrencySymbol,
        departmentName: orderHeader.departmentName,
        harborName: orderHeader.harborName,
        countryName: orderHeader.countryName,
        supplierCurrencyCode: orderHeader.supplierCurrencyCode,
        supplierCurrencyID: orderHeader.supplierCurrencyID,
        supplierCurrencySymbol: orderHeader.supplierCurrencySymbol,
        statusID: orderHeader.statusID,
        statusDesc: orderHeader.statusDesc,
        agentName: orderHeader.agentName,
        agentTelephone: orderHeader.agentTelephone,
        agentEmail: orderHeader.agentEmail,
        priceRequestHeaderID: orderHeader.priceRequestHeaderID,
        orderHandlerID: orderHeader.orderHandlerID,
        //hasOrderList: orderHeader.hasOrderList
        toRecover: orderHeader.toRecover,
        isHolidayOrder: orderHeader.isHolidayOrder,
        isBarge: orderHeader.isBarge,
        skipCatalog: orderHeader.skipCatalog,
        isExtraListOrder: orderHeader.isExtraListOrder,
        inScope: orderHeader.inScope,
        isIMI: orderHeader.isIMI,
        imiOrderInfoHeaderID: orderHeader.imiOrderInfoHeaderID,
        isOffshoreSupply: orderHeader.isOffshoreSupply,
      };

      this.dbxService.openDatabase().then(db => {
        //console.log('this.idbContext().then');
        const tx = db.transaction('OWS_tblOrderInfoHeader', 'readwrite');
        tx.oncomplete = (ev) => {

        }
        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        let store = tx.objectStore('OWS_tblOrderInfoHeader');
        try {
          let req = store.put(obj).then(
            (res: any) => {
              resolve(res);
            }
          )
        } catch (e: any) {
          if (e?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        }
        return tx.done;// complete;
      });

    });
    return promise;
  }

  getOrderHeaderLastSeq(ID: string): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {

      this.dbxService.openDatabase().then(db => {
        //console.log('this.idbContext().then');
        const tx = db.transaction('OWS_tblOrderHeaderLastSeq', 'readwrite');
        tx.oncomplete = (ev) => {

        }
        tx.onerror = (err) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblOrderHeaderLastSeq');
        store.get(ID).then(
          (res: any) => {
            resolve(res);
          }
        )
        // return tx.done;// complete;
      });

    });
    return promise;
  }

  insertOrderHeaderLastSeq(ID: string, seq: any) {
    const obj = {
      ID: ID,
      Seq: seq,
    };

    this.dbxService.openDatabase().then(db => {
      //console.log('this.idbContext().then');
      const tx = db.transaction('OWS_tblOrderHeaderLastSeq', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      let store = tx.objectStore('OWS_tblOrderHeaderLastSeq');
      try {
        let req = store.add(obj);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }

      return tx.done;// complete;
    });
  }
  updateOrderHeaderLastSeq(ID: string, seq: any) {
    const obj = {
      ID: ID,
      Seq: seq,
    };

    this.dbxService.openDatabase().then(db => {
      //console.log('this.idbContext().then');
      const tx = db.transaction('OWS_tblOrderHeaderLastSeq', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      let store = tx.objectStore('OWS_tblOrderHeaderLastSeq');
      try {
        let req = store.put(obj);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }

      return tx.done;// complete;
    });
  }
  updateOrderHeader(orderHeaderGUID: string, orderHeader: any) {
    const obj = {
      orderInfoHeaderID: orderHeaderGUID,
      agentID: orderHeader.agentID,
      captainID: orderHeader.captainID,
      campbossID: orderHeader.campbossID,
      cookID: orderHeader.cookID,
      countryID: orderHeader.countryID,
      coveringDays: orderHeader.coveringDays,
      coveringDaysFreshFood: orderHeader.coveringDaysFreshFood,
      orderDate: orderHeader.orderDate,
      deliveryDate: orderHeader.deliveryDate,
      departmentID: orderHeader.departmentID,
      harborID: orderHeader.harborID,
      nextCountryID: orderHeader.nextCountryID,
      nextHarborID: orderHeader.nextHarborID,
      noOfCrew: orderHeader.noOfCrew,
      orderReviewerID: orderHeader.orderReviewerID,
      // orderHeaderID: orderHeaderGUID,
      shipID: orderHeader.shipID,
      shipName: orderHeader.shipName,
      supplierID: orderHeader.supplierID,
      supplierName: orderHeader.supplierName,
      orderListSupplierID: orderHeader.orderListSupplierID,
      orderListSupplierCurrencyID: orderHeader.orderListSupplierCurrencyID,
      orderListSupplierCurrencyCode: orderHeader.orderListSupplierCurrencyCode,
      orderListSupplierCurrencySymbol: orderHeader.orderListSupplierCurrencySymbol,
      departmentName: orderHeader.departmentName,
      harborName: orderHeader.harborName,
      countryName: orderHeader.countryName,
      supplierCurrencyCode: orderHeader.supplierCurrencyCode,
      supplierCurrencyID: orderHeader.supplierCurrencyID,
      supplierCurrencySymbol: orderHeader.supplierCurrencySymbol,
      statusID: orderHeader.statusID,
      statusDesc: orderHeader.statusDesc,
      agentName: orderHeader.agentName,
      agentTelephone: orderHeader.agentTelephone,
      agentEmail: orderHeader.agentEmail,
      priceRequestHeaderID: orderHeader.priceRequestHeaderID,
      orderHandlerID: orderHeader.orderHandlerID,
      isUpdateOffline: orderHeader.isUpdateOffline,
      toRecover: orderHeader.toRecover ? orderHeader.toRecover : false,
      isHolidayOrder: orderHeader.isHolidayOrder ? orderHeader.isHolidayOrder : false,
      // hasOrderList: orderHeader.hasOrderList
      isBarge: orderHeader.isBarge ? orderHeader.isBarge : false,
      skipCatalog: orderHeader.skipCatalog ? orderHeader.skipCatalog : false,
      isExtraListOrder: orderHeader.isExtraListOrder ? orderHeader.isExtraListOrder : false,
      inScope: orderHeader.inScope ? orderHeader.inScope : false,
      isIMI: orderHeader.isIMI ? orderHeader.isIMI : false,
      imiOrderInfoHeaderID: orderHeader.imiOrderInfoHeaderID ? orderHeader.imiOrderInfoHeaderID : 0,
      isOffshoreSupply: orderHeader.isOffshoreSupply ? orderHeader.isOffshoreSupply : false,
    };
    this.dbxService.openDatabase().then(db => {
      //console.log('this.idbContext().then');
      const tx = db.transaction('OWS_tblOrderInfoHeader', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      let store = tx.objectStore('OWS_tblOrderInfoHeader');
      try {
        let req = store.put(obj);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }

      return tx.done;// complete;
    });
  }

  getOrderHeaderIndxdb(orderHeaderGUID: string): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {

      this.dbxService.openDatabase().then(db => {
        //console.log('this.idbContext().then');
        const tx = db.transaction('OWS_tblOrderInfoHeader', 'readwrite');
        tx.oncomplete = (ev) => {

        }
        tx.onerror = (err) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblOrderInfoHeader');
        store.get(orderHeaderGUID).then(
          (res: any) => {
            resolve(res);
          }
        )
        // return tx.done;// complete;
      });

    });
    return promise;
  }

  getOrderListIndxdb(orderHeaderGUID: string): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {

      this.dbxService.openDatabase().then(db => {
        //console.log('this.idbContext().then');
        const tx = db.transaction('OWS_tblOrderList', 'readwrite');
        tx.oncomplete = (ev) => {

        }
        tx.onerror = (err) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblOrderList');
        store.get(orderHeaderGUID).then(
          (res: any) => {
            resolve(res);
          }
        )
        // return tx.done;// complete;
      });

    });
    return promise;
  }

  saveOrderList(orderListGUID: string, orderList: any) {
    const obj = {
      orderListID: orderListGUID,
      orderList: orderList,

    };

    this.dbxService.openDatabase().then(db => {
      //console.log('this.idbContext().then');
      const tx = db.transaction('OWS_tblOrderList', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      let store = tx.objectStore('OWS_tblOrderList');
      try {
        let req = store.add(obj);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }
    });
  }

  updateOrderList(orderListGUID: string, orderList: any) {
    const obj = {
      orderListID: orderListGUID,
      orderList: orderList,

    };

    this.dbxService.openDatabase().then(db => {
      //console.log('this.idbContext().then');
      const tx = db.transaction('OWS_tblOrderList', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      let store = tx.objectStore('OWS_tblOrderList');
      try {
        let req = store.put(obj);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }

      return tx.done;// complete;
    });
  }

  deleteOrderList(orderListGUID: string): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblOrderList', 'readwrite');
        tx.oncomplete = (ev) => {

        }
        tx.onerror = (err) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblOrderList');
        let req = store.delete(orderListGUID);

        tx.done;// complete;

        resolve(true);
      });
    });
    return promise;
  }


  getWeightByCategoryIndxdb(ID: string): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {

      this.dbxService.openDatabase().then(db => {
        //console.log('this.idbContext().then');
        const tx = db.transaction('OWS_tblOrderWeightByCategory', 'readwrite');
        tx.oncomplete = (ev) => {

        }
        tx.onerror = (err) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblOrderWeightByCategory');
        store.get(ID).then(
          (res: any) => {
            resolve(res);
          }
        )
        // return tx.done;// complete;
      });

    });
    return promise;
  }

  saveWeightByCategory(ID: string, orderWeightByCategoryList: any) {
    const obj = {
      orderWeightByCategoryID: ID,
      orderWeightByCategoryList: orderWeightByCategoryList,

    };

    this.dbxService.openDatabase().then(db => {
      //console.log('this.idbContext().then');
      const tx = db.transaction('OWS_tblOrderWeightByCategory', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      let store = tx.objectStore('OWS_tblOrderWeightByCategory');
      try {
        let req = store.add(obj);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }
    });
  }

  updateWeightByCategory(ID: string, orderWeightByCategoryList: any) {
    const obj = {
      orderWeightByCategoryID: ID,
      orderWeightByCategoryList: orderWeightByCategoryList,

    };

    this.dbxService.openDatabase().then(db => {
      //console.log('this.idbContext().then');
      const tx = db.transaction('OWS_tblOrderWeightByCategory', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      let store = tx.objectStore('OWS_tblOrderWeightByCategory');
      try {
        let req = store.put(obj);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }

      return tx.done;// complete;
    });
  }


  getShipBudgetInfoIndxdb(ID: string): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {

      this.dbxService.openDatabase().then(db => {
        //console.log('this.idbContext().then');
        const tx = db.transaction('OWS_tblShipBudgetInfo', 'readwrite');
        tx.oncomplete = (ev) => {

        }
        tx.onerror = (err) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblShipBudgetInfo');
        store.get(ID).then(
          (res: any) => {
            resolve(res);
          }
        )
        // return tx.done;// complete;
      });

    });
    return promise;
  }

  saveShipBudgetInfoIndxdb(ID: string, shipBudgetInfo: any) {
    const obj = {
      shipBudgetID: ID,
      allownaceInSupCurr: shipBudgetInfo[0].budgetAllowanceInSupplierCurr,
      budgetInPercentage: shipBudgetInfo[0].budgetInPercentage,
      priceMenDay: shipBudgetInfo[0].priceMenDay,
      priceMenDayCurrencyCode: shipBudgetInfo[0].priceMenDayCurrencyCode,
      priceMenDayCurrencyID: shipBudgetInfo[0].priceMenDayCurrencyID,
      priceMenDayCurrencySymbol: shipBudgetInfo[0].priceMenDayCurrencySymbol,
      budgetInMoney: shipBudgetInfo[0].budgetInMoney,
      budgetForFreshFruitVegetable: shipBudgetInfo[0].budgetForFreshFruitVegetable,
      holidayOrderFixedAllowance: shipBudgetInfo[0].holidayOrderFixedAllowance,
      estimatedStockBeforeDeliveryValue: shipBudgetInfo[0].estimatedStockBeforeDeliveryValue,
      estimatedStockBeforeDeliveryDays: shipBudgetInfo[0].estimatedStockBeforeDeliveryDays,
    };

    this.dbxService.openDatabase().then(db => {
      //console.log('this.idbContext().then');
      const tx = db.transaction('OWS_tblShipBudgetInfo', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      let store = tx.objectStore('OWS_tblShipBudgetInfo');
      try {
        let req = store.add(obj);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }
    });
  }

  updateShipBudgetInfoIndxdb(ID: string, shipBudgetInfo: any) {
    const obj = {
      shipBudgetID: ID,
      allownaceInSupCurr: shipBudgetInfo[0].budgetAllowanceInSupplierCurr,
      budgetInPercentage: shipBudgetInfo[0].budgetInPercentage,
      priceMenDay: shipBudgetInfo[0].priceMenDay,
      priceMenDayCurrencyCode: shipBudgetInfo[0].priceMenDayCurrencyCode,
      priceMenDayCurrencyID: shipBudgetInfo[0].priceMenDayCurrencyID,
      priceMenDayCurrencySymbol: shipBudgetInfo[0].priceMenDayCurrencySymbol,
      budgetInMoney: shipBudgetInfo[0].budgetInMoney,
      budgetForFreshFruitVegetable: shipBudgetInfo[0].budgetForFreshFruitVegetable,
      holidayOrderFixedAllowance: shipBudgetInfo[0].holidayOrderFixedAllowance,
      estimatedStockBeforeDeliveryValue: shipBudgetInfo[0].estimatedStockBeforeDeliveryValue,
      estimatedStockBeforeDeliveryDays: shipBudgetInfo[0].estimatedStockBeforeDeliveryDays,
    };

    this.dbxService.openDatabase().then(db => {
      //console.log('this.idbContext().then');
      const tx = db.transaction('OWS_tblShipBudgetInfo', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      let store = tx.objectStore('OWS_tblShipBudgetInfo');
      try {
        let req = store.put(obj);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }

      return tx.done;// complete;
    });
  }

  getShipMaxOrderBudgetForFreshFoodIndxdb(ID: string): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {

      this.dbxService.openDatabase().then(db => {
        //console.log('this.idbContext().then');
        const tx = db.transaction('OWS_tblShipMaxOrderBudget', 'readwrite');
        tx.oncomplete = (ev) => {

        }
        tx.onerror = (err) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblShipMaxOrderBudget');
        store.get(ID).then(
          (res: any) => {
            resolve(res);
          }
        )
        // return tx.done;// complete;
      });

    });
    return promise;
  }

  saveShipMaxOrderBudgetForFreshFood(ID: string, categoryGroup: any, shipMaxOrderBudget: any) {
    const obj = {
      shipOrderBudgetID: ID,
      categoryGroup: categoryGroup,
      shipMaxOrderBudget: shipMaxOrderBudget,

    };

    this.dbxService.openDatabase().then(db => {
      //console.log('this.idbContext().then');
      const tx = db.transaction('OWS_tblShipMaxOrderBudget', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      let store = tx.objectStore('OWS_tblShipMaxOrderBudget');
      try {
        let req = store.add(obj);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }
    });
  }

  updateShipMaxOrderBudgetForFreshFood(ID: string, categoryGroup: any, shipMaxOrderBudget: any) {
    const obj = {
      shipOrderBudgetID: ID,
      categoryGroup: categoryGroup,
      shipMaxOrderBudget: shipMaxOrderBudget,

    };

    this.dbxService.openDatabase().then(db => {
      //console.log('this.idbContext().then');
      const tx = db.transaction('OWS_tblShipMaxOrderBudget', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      let store = tx.objectStore('OWS_tblShipMaxOrderBudget');
      try {
        let req = store.put(obj);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }

      return tx.done;// complete;
    });
  }


  getExchangeRateIndxdb(ID: string): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {

      this.dbxService.openDatabase().then(db => {
        //console.log('this.idbContext().then');
        const tx = db.transaction('OWS_tblExchangeRate', 'readwrite');
        tx.oncomplete = (ev) => {

        }
        tx.onerror = (err) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblExchangeRate');
        store.get(ID).then(
          (res: any) => {
            resolve(res);
          }
        )
        // return tx.done;// complete;
      });

    });
    return promise;
  }

  getAllExchangeRateIndxdb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {

      this.dbxService.openDatabase().then(db => {
        //console.log('this.idbContext().then');
        const tx = db.transaction('OWS_tblExchangeRate', 'readwrite');
        tx.oncomplete = (ev) => {

        }
        tx.onerror = (err) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblExchangeRate');
        store.getAll().then(
          (res: any) => {
            resolve(res);
          }
        )
        // return tx.done;// complete;
      });

    });
    return promise;
  }

  saveExchangeRateIndxdb(ID: string, exchngRate: any) {
    const obj = {
      exchangeRateID: ID,
      exchangeRate: exchngRate.exchangeRate,
      fromCurrencyCode: exchngRate.fromCurrencyCode,
      fromCurrencySymbol: exchngRate.fromCurrencySymbol,
      fromCurrencyID: exchngRate.fromCurrencyID,
      toCurrencyCode: exchngRate.toCurrencyCode,
      toCurrencyID: exchngRate.toCurrencyID,
      toCurrencySymbol: exchngRate.toCurrencySymbol
    };

    this.dbxService.openDatabase().then(db => {
      //console.log('this.idbContext().then');
      const tx = db.transaction('OWS_tblExchangeRate', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      let store = tx.objectStore('OWS_tblExchangeRate');
      try {
        let req = store.add(obj);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }
    });
  }

  updateExchangeRateIndxdb(ID: string, exchngRate: any) {
    const obj = {
      exchangeRateID: ID,
      exchangeRate: exchngRate.exchangeRate,
      fromCurrencyCode: exchngRate.fromCurrencyCode,
      fromCurrencySymbol: exchngRate.fromCurrencySymbol,
      fromCurrencyID: exchngRate.fromCurrencyID,
      toCurrencyCode: exchngRate.toCurrencyCode,
      toCurrencyID: exchngRate.toCurrencyID,
      toCurrencySymbol: exchngRate.toCurrencySymbol
    };

    this.dbxService.openDatabase().then(db => {
      //console.log('this.idbContext().then');
      const tx = db.transaction('OWS_tblExchangeRate', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      let store = tx.objectStore('OWS_tblExchangeRate');
      try { 
      let req = store.put(obj);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }

      return tx.done;// complete;
    });
  }
  pushCountryTblRefIndexDB(id: any, dataList: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      const obj = {
        ID: id,
        refList: dataList
      };

      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblReferenceList', 'readwrite');
        tx.oncomplete = (ev) => {

        }
        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        let store = tx.objectStore('OWS_tblReferenceList');
        //let req = store.add(obj).then(
        //  (res: any) => {
        //    resolve(res);
        //  }
        //)
        store.get(obj.ID).then((res: any) => {
          if (res == null) {
            try {
              store.add(obj);
            } catch (e: any) {
              if (e?.name === 'QuotaExceededError') {
                this.handleQuotaExceeded();
              }
            }
          } else {
            try {
              store.put(obj);
            } catch (e: any) {
              if (e?.name === 'QuotaExceededError') {
                this.handleQuotaExceeded();
              }
            }
          }
        })

        return tx.done;// complete;

      });
    });
    return promise;
  }
  getCountryTblRefIndexDB(id: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        //console.log('this.idbContext().then');
        const tx = db.transaction('OWS_tblReferenceList', 'readwrite');
        tx.oncomplete = (ev) => {
          console.log('tx.oncomplete');
        }
        tx.onerror = (err) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblReferenceList');
        store.get(id).then(
          (res: any) => {
            //console.log(res);
            resolve(res);
          }
        )
        // return tx.done;// complete;
      });

    });
    return promise;
  }


  pushShipDepartmentIndexDB(id: any, dataList: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      const obj = {
        ShipID: id,
        refList: dataList
      };

      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblShipDepartmentList', 'readwrite');
        tx.oncomplete = (ev) => {

        }
        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        let store = tx.objectStore('OWS_tblShipDepartmentList');
        //let req = store.add(obj).then(
        //  (res: any) => {
        //    resolve(res);
        //  }
        //)
        store.get(obj.ShipID).then((res: any) => {
          if (res == null) {
            try {
              store.add(obj);
            } catch (e: any) {
              if (e?.name === 'QuotaExceededError') {
                this.handleQuotaExceeded();
              }
            }
          } else {
            try {
              store.put(obj);
            } catch (e: any) {
              if (e?.name === 'QuotaExceededError') {
                this.handleQuotaExceeded();
              }
            }
          }
        })

        return tx.done;// complete;

      });
    });
    return promise;
  }
  getShipDepartmentIndexDB(id: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        //console.log('this.idbContext().then');
        const tx = db.transaction('OWS_tblShipDepartmentList', 'readwrite');
        tx.oncomplete = (ev) => {
          console.log('tx.oncomplete');
        }
        tx.onerror = (err) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblShipDepartmentList');
        store.get(id).then(
          (res: any) => {
            //console.log(res);
            resolve(res);
          }
        )
        // return tx.done;// complete;
      });

    });
    return promise;
  }




  getTemplate(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {


    });
    return promise;
  }

  getIMIOrderInfoHeader(orderInfoHeaderID: number) {

    // convert to httpPost
    let paramObject = {
      'orderInfoHeaderID': orderInfoHeaderID
    }

    return this.http.post(Helper.API_URL() + '/api/Orders/GetIMIOrderInfoHeader', paramObject);
  }

  handleQuotaExceeded() {
    swal
      .fire({
        title: 'Error',
        html: '<span>IndexedDB storage qouta exceeded.</span>',
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
      .then((result) => {
        if (result.value) {
        }
      });
  }

}
